export default function Spinner({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="flex items-center justify-center py-24" role="status" aria-live="polite">
      <span className="h-6 w-6 animate-spin rounded-full border-2 border-ink-200 border-t-gold-500" />
      <span className="sr-only">{label}</span>
    </div>
  );
}
